module.exports = __webpack_public_path__ + "img/6a8e412.png";